import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { ModalDirective } from 'ng2-bootstrap/components/modal/modal.component';

import { LoaderEvent } from '../../shared/message.event';
import { AuthenticationService } from '../shared/authentication.service';
import { Encryption } from './../../shared/encryption';

@Component({
    selector: 'shared-child-modal',
    templateUrl: './change-password.component.html',
    styleUrls: ['./change-password.component.css'],
    providers: [AuthenticationService, LoaderEvent],
    exportAs: 'changePasswordPopup'
})
export class ChangePasswordPopupComponent implements OnInit {
    @ViewChild('childModal') childModal: ModalDirective;
    @Input() message = '';
    @Input() popupTitle;
    @Input() vendor;
    @Output() notify = new EventEmitter<boolean>();
    @Output() facilityid = new EventEmitter<string>();
    private password = {
        old: '',
        new: '',
        confirm: ''
    };
    private validate = {
        old: '',
        new: '',
        flag: true,
        confirm: ''
    }
    constructor(public router: Router, private loaderEvent: LoaderEvent, private authenticationService: AuthenticationService) {
    }
    ngOnInit() {
    }

    public showChildModal(flag): void {
        try {
            this.setPasswordObjFields();
            this.childModal.config.backdrop = false;
            this.childModal.config.keyboard = false;
            this.childModal.show();
        } catch (e) {
            console.log(e);
        }
    }

    public hideChildModal(): void {
        try {
            this.childModal.hide();
        } catch (e) {
            console.log(e);
        }
    }

    onClickOk() {
        try {
            this.hideChildModal();
        } catch (e) {
            console.log(e);
        }
    }

    onClickCancle() {
        try {
            this.hideChildModal();
        } catch (e) {
            console.log(e);
        }
    }

    validatePassword(para, event) {
        let flag = false;
        switch (para) {
            case 'old':
                if (this.password.old) {
                    this.validate.old = '';
                    flag = true;
                } else {
                    this.validate.old = 'required';
                    flag = false;
                }
                break;
            case 'new':
                if (event && event.keyCode !== 9) {
                    if (this.password.new) {
                        this.validate.new = '';
                        flag = true;
                    } else {
                        this.validate.new = 'required';
                        flag = false;
                    }
                }
                break;
            case 'confirm':
                if (event && event.keyCode !== 9) {
                    if (this.password.confirm) {
                        this.validate.confirm = '';
                        flag = true;
                    } else {
                        this.validate.confirm = 'required';
                        flag = false;
                    }
                }
                break;

            case '':
                if (this.password.old) {
                    this.validate.old = '';
                    flag = true;
                } else {
                    this.validate.old = 'required';
                    flag = false;
                }
                if (this.password.new) {
                    this.validate.new = '';
                    flag = true;
                } else {
                    this.validate.new = 'required';
                    flag = false;
                }
                if (this.password.confirm) {
                    this.validate.confirm = '';
                    flag = true;
                } else {
                    this.validate.confirm = 'required';
                    flag = false;
                }
                break;
        }
        return flag;
    }

    changPasswordOfVendor(popopObj) {
        if (this.matchPassword() && this.validatePassword('', '') && this.validateLength()) {
            let changPasswordObj = {
                "vendorId": this.vendor['_id'],
                "newPassword": this.password.new,
                "oldPassword": this.password.old
            }
            let encryption = new Encryption();
            encryption.hash(changPasswordObj.newPassword)
                .then((hashed) => {
                    changPasswordObj.newPassword = hashed
                });
            encryption.hash(changPasswordObj.oldPassword)
                .then((hashed) => {
                    changPasswordObj.oldPassword = hashed
                });
            let that = this;
            setTimeout(function () {
                that.authenticationService.changePassword(changPasswordObj).then((result: any) => {
                    that.message = result.message;
                    if (result.status === 'SUCCESS') {
                        that.setPasswordObjFields();
                        that.hideChildModal();
                        popopObj.showChildModal();
                    } else {
                        that.validate.flag = false;
                    }
                });
            }, 100);

        } else {
        }
    }

    matchPassword() {
        if (this.password.confirm && this.password.new && this.password.confirm != this.password.new) {
            this.message = '* Password is not matching';
            this.validate.flag = false
        } else {
            this.message = '';
            this.validate.flag = true
        }
        return this.validate.flag;
    }

    validateLength() {
        if (this.password.new && this.password.new.length < 1) {
            this.message = '* Use at least 1 characters';
            this.validate.flag = false;
        } else {
            this.message = ''
            this.validate.flag = true;
        }
        return this.validate.flag
    }

    setPasswordObjFields() {
        this.password.old = '';
        this.password.new = '';
        this.password.confirm = '';
        this.validate.old = '';
        this.validate.new = '';
        this.validate.flag = true;
        this.validate.confirm = '';
    }

}




// WEBPACK FOOTER //
// ./src/app/authentication/change-password/change-password.component.ts